// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._headerContainer_1cubo_1 {
	display: flex;
	margin-bottom: var(--lok-spacing-1);
	width: 100%;
	align-items: center;
}

._navigationTabList_1cubo_8 {
	display: flex;
	list-style: none;
	flex-wrap: wrap;
	margin: 0 0 0 calc(-1 * var(--lok-spacing-6));
	padding: 0;
}

._navigationTab_1cubo_8 {
	border: none;
	margin: 0;
	border-bottom: 2px solid transparent;
	background: none;
	appearance: none;

	font: var(--lok-typography-body-small-default);
	color: var(--lok-color-text-default);
	margin: 0 0 0 var(--lok-spacing-6);

	&[aria-selected='true'] {
		font-weight: 500;
		color: var(--lok-color-text-active);
		border-bottom-color: var(--lok-color-text-active);
	}
}

._headerContent_1cubo_34 {
	position: fixed;
	background-color: var(--lok-color-background-surface-default);
	top: 0;
	left: 95px;
	right: 32px;
	z-index: 899;

	padding-top: var(--lok-spacing-5);
	padding-left: 30px;
	padding-right: 30px;
	margin-left: -30px;
	margin-right: -30px;
	border-bottom: 1px solid var(--lok-color-border-default);
}

._staticEnabled_1cubo_50 {
	z-index: var(--lok-z-index-auto);
	position: relative;
	top: inherit;
	left: 0;
	right: 0;
	padding-top: 0;
	box-shadow: none;
}
._sidebarContainer_bmdti_1 {
	border-right: 1px solid var(--lok-color-border-default);
	position: fixed;
	width: 65px;
	top: 0;
	left: 0;
	bottom: 0;
	background-color: var(--lok-color-background-surface-middle);
	display: flex;
	justify-content: space-between;
	flex-direction: column;
	padding-bottom: var(--lok-spacing-3);
	z-index: 1;
}

._logoLink_bmdti_16 {
	display: flex;
	align-items: center;
	justify-content: center;
	height: 67px;
	position: relative;

	&:hover {
		background-color: var(--lok-color-background-surface-middle);
	}

	> img {
		width: 36px;
	}
}
._logoLink_1baxb_1 {
	display: flex;
	align-items: center;
	justify-content: center;
	height: 67px;
	position: relative;

	&:hover {
		background-color: var(--lok-color-background-surface-middle);
	}

	> img {
		width: 36px;
	}
}
._link_18vhx_1._link_18vhx_1 {
	display: flex;
	justify-content: center;
	align-items: center;
	height: 65px;
	width: 64px;
	background: transparent;
	border: none;
	outline: none;
	color: var(--lok-color-text-light-default);

	&:hover {
		color: var(--lok-color-background-action-primary-default);
		background-color: var(--lok-color-background-surface-fore);
	}
}

._active_18vhx_18._active_18vhx_18 {
	color: var(--lok-color-background-action-primary-default);
	background-color: var(--lok-color-background-surface-fore);
}
._dropdownButton_1naek_1 {
	cursor: pointer;
	display: flex;
	justify-content: center;
	align-items: center;
	height: 65px;
	width: 64px;
	background: transparent;
	border: none;
	outline: none;
	color: var(--lok-color-text-light-default);

	&:hover {
		color: var(--lok-color-background-action-primary-default);
		background-color: var(--lok-color-background-surface-fore);
	}
}

._dropdownButtonActive_1naek_19 {
	color: var(--lok-color-background-action-primary-default);
	background-color: var(--lok-color-background-surface-fore);
}
._iconContainer_nz34m_1 {
	color: var(--lok-color-background-surface-default);
	background-color: var(--lok-color-background-action-danger-default);
	border-radius: 100%;
	font-size: 10px;
	height: 16px;
	width: 16px;
}
:root {
	--menu-container-width: 300px;
	--profile-button-size: 65px;
}

._popoverContent_1phdw_6 {
	width: var(--menu-container-width);
}

._menuContainer_1phdw_10 {
	width: var(--menu-container-width);
	font-size: var(--lok-font-size-small);
	button,
	a {
		font-size: var(--lok-font-size-small);
		padding: var(--lok-spacing-3) var(--lok-spacing-4);
	}
}

._profileButton_1phdw_20 {
	cursor: pointer;
	position: relative;
	border: none;
	background: transparent;
	height: var(--profile-button-size);
	width: var(--profile-button-size);

	&:hover {
		background: none;
	}
}

._profileImage_1phdw_33 {
	width: 40px;
	height: 40px;
	border-radius: 100%;
	background-color: var(--lok-color-background-surface-default);
	object-fit: contain; /* Make sure that non-square images maintain their aspect ratio */
}

._profileImageHighlight_1phdw_41 {
	border: 3px solid var(--lok-color-background-action-danger-default);
}

._profileImageUpgradeIcon_1phdw_45 {
	position: absolute;
	bottom: 10px;
	right: 10px;
}

._userIconWrapper_1phdw_51 {
	width: 45px;
	height: 45px;
	display: flex;
	align-items: center;
	border-radius: var(--lok-radius-rounded);
	justify-content: center;
	margin: auto;
}
._container_q5pot_1 {
	max-width: 100%;
}

._profileEmail_q5pot_5 {
	color: var(--lok-color-text-light-default);
	font-size: var(--lok-font-size-tiny);
	max-width: 100%;
	overflow: hidden;
	text-overflow: ellipsis;
}
:root {
	--profile-image-size: 40px;
}

._wrapper_1in7x_5 {
	padding: var(--lok-spacing-3) var(--lok-spacing-4);
	gap: var(--lok-spacing-2);
	display: flex;
}

._profileImage_1in7x_11 {
	width: var(--profile-image-size);
	height: var(--profile-image-size);
	border-radius: 100%;
	background-color: var(--lok-color-background-surface-default);
	object-fit: contain;
}

._teamDetails_1in7x_19 {
	align-items: flex-start;
	display: flex;
	flex-direction: column;
	flex: 1;
	gap: 1px; /* TODO: use spacing token when available */
	min-width: 0;
}

._planWrapper_1in7x_28 {
	align-items: center;
	display: flex;
	flex-wrap: nowrap;
	gap: var(--lok-spacing-2);
	width: 100%;
}

._teamName_1in7x_36 {
	flex: 1;
	font: var(--lok-typography-body-base-default);
	min-width: 0;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

._planLabel_1in7x_45 {
	background-color: var(--lok-color-background-danger);
	border-radius: var(--lok-radius-rounded);
	font: var(--lok-typography-body-tiny-default);
	padding: 2px var(--lok-spacing-2); /* TODO: use spacing token when available */
	white-space: nowrap;
}

._membership_1in7x_53 {
	color: var(--lok-color-text-light-default);
	font: var(--lok-typography-body-action-base);
	text-transform: capitalize;
}

._defaultProfileImage_1in7x_59 {
	width: var(--profile-image-size);
	height: var(--profile-image-size);
}
:root {
	--profile-image-size: 40px;
}

._teamsContainer_1ncrr_5 {
	width: 100%;
	/* Fix for overflowing menu when there is a lot of teams to select from.
     * This should be changed in the future to something more user friendly.
     * Fits easily 5 teams (on landscape iPad) - should cover 95%+ of cases. */
	max-height: 350px;
	overflow-x: hidden;
	overflow-y: auto;
}

._profileImage_1ncrr_15 {
	width: var(--profile-image-size);
	height: var(--profile-image-size);
	border-radius: 100%;
	background-color: var(--lok-color-background-surface-default);
	object-fit: contain;
}
._container_1u995_1 {
	max-width: 100%;
	min-width: 0;
	padding: var(--lok-spacing-3) var(--lok-spacing-4);
	background: var(--lok-color-background-surface-middle);
	border: 0;

	&:hover {
		._upgrade-icon_1u995_9 {
			color: var(--lok-color-text-inverse);
		}
	}
}

._planCta_1u995_15 {
	font: var(--lok-typography-body-small-default);
}

._upgradeIconWrapper_1u995_19 {
	color: var(--lok-color-text-danger);
	font: var(--lok-typography-body-small-strong);
	height: 16px;
}
._navItem_1dudv_1._navItem_1dudv_1 {
	border: 0;
	background: none;
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	position: relative;
	height: 65px;
	color: var(--lok-color-text-light-default);

	&:hover {
		color: var(--lok-color-background-action-primary-default);
		background-color: var(--lok-color-background-surface-fore);
	}
}

._activeNavItem_1dudv_18 {
	color: var(--lok-color-background-action-primary-default);
	background-color: var(--lok-color-background-surface-fore);
}

._badge_1dudv_23 {
	position: absolute;
	top: calc(50% - 16px);
	left: calc(50% + 2px);

	display: flex;
	align-items: center;
	justify-content: center;
	text-align: center;

	width: 16px;
	height: 16px;
	border-radius: var(--lok-radius-rounded);
	background-color: var(--lok-color-text-danger);

	font-size: var(--lok-font-size-tiny);
	text-transform: uppercase;
	color: var(--lok-color-text-inverse);
}
._langRowCompleted_vpgdi_1 {
	background: var(--lok-color-background-info);
	td {
		overflow: hidden;
		text-overflow: ellipsis;
		text-align: start;

		&:first-child {
			border-left: 2px solid
				var(--lok-color-background-action-primary-default);
		}
	}
}

._langCellSecondary_vpgdi_15 {
	color: var(--lok-color-text-light-default);
	text-align: left;
}

._langStatus_vpgdi_20 {
	color: var(--lok-color-text-light-default);

	&::before {
		display: inline-block;
		content: '';
		width: 6px;
		height: 6px;
		border-radius: 50%;
		margin: var(--lok-spacing-1);
		background-color: #cbd5e0;
	}

	&[data-status='completed'] {
		&::before {
			background-color: #60e778;
		}
	}

	&[data-status='in_progress'] {
		&::before {
			background-color: #facc15;
		}
	}
}
._taskContainer_mt2or_1 {
	padding: var(--lok-spacing-4);
	position: relative;

	&:not(:first-child)::before {
		display: block;
		content: '';
		height: 1px;
		width: calc(100% - 2 * var(--lok-spacing-4));
		position: absolute;
		top: 0;
		left: var(--lok-spacing-4);
		background: var(--lok-color-background-surface-fore);
	}
}

._tagDue_mt2or_17 {
	background: #dea829;
}

._taskTitle_mt2or_21 {
	font: var(--lok-typography-body-small-default);
	overflow: hidden;
	text-overflow: ellipsis;
	margin-block: var(--lok-spacing-4) var(--lok-spacing-2);
}

._taskDescription_mt2or_28 {
	color: var(--lok-color-text-light-default);
	font: var(--lok-typography-body-action-small);
	overflow: hidden;
	text-overflow: ellipsis;
}

._languagesTable_mt2or_35 {
	table-layout: fixed;
	margin-top: var(--lok-spacing-3);
	width: auto;
	margin-left: calc(var(--lok-spacing-4) * -1);
	border-collapse: separate;

	tbody td {
		padding-top: var(--lok-spacing-1);
		padding-bottom: var(--lok-spacing-1);
	}

	thead th:first-child,
	tbody td:first-child {
		padding-left: var(--lok-spacing-4);
	}

	thead th,
	tbody td {
		padding-left: var(--lok-spacing-2);
	}

	thead th:last-child,
	tbody td:last-child {
		padding-right: var(--lok-spacing-4);
	}

	thead tr th {
		color: var(--lok-color-text-light-default);
		text-align: left;
		padding-bottom: var(--lok-spacing-1);
		font: var(--lok-typography-body-tiny-default);
		text-transform: uppercase;

		&:nth-child(1) {
			width: 170px;
		}

		&:nth-child(2) {
			width: 107px;
		}

		&:nth-child(3) {
			width: 75px;
		}

		&:nth-child(4) {
			width: 118px;
		}
	}
}

._metadata_mt2or_87 {
	color: var(--lok-color-text-light-default);
	margin: var(--lok-spacing-4) 0 0;
	font: var(--lok-typography-body-tiny-default);

	> span {
		overflow: hidden;
		text-overflow: ellipsis;
		flex-basis: 100%;
		max-width: max-content;

		&:not(:first-child) {
			margin-left: var(--lok-spacing-1);
		}

		&:not(:first-child)::before {
			content: '•';
			margin-right: var(--lok-spacing-1);
		}
	}
}
._loadingContainer_19d6m_1 {
	height: 100px;
	width: 487px;
	left: 69px;
}

._noTasksContainer_19d6m_7 {
	text-align: center;
	padding: var(--lok-spacing-8);
	width: 360px;
	left: 65px;
}

._noTasksHeading_19d6m_14 {
	font: var(--lok-typography-heading-3);
}

._noTasksText_19d6m_18 {
	font: var(--lok-typography-body-action-base);
	color: var(--lok-color-text-light-default);
}

._tasksContainer_19d6m_23 {
	width: 487px;
	max-height: 70vh;
	overflow-y: auto;
	overflow-x: hidden;
	left: 65px;
}
._breadcrumbsItem_1hm6a_1 {
	color: var(--lok-color-text-light-default);

	text-decoration: none;
}

._breadcrumbs_1hm6a_1 {
	font: var(--lok-typography-body-small-default);

	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;

	margin-right: var(--lok-spacing-1);
	max-width: 90%;

	& > * {
		white-space: nowrap;
	}
}
._badge_1pc1v_1 {
	position: absolute;
	top: 5px;
	right: -13px;
	background-color: var(--lok-color-background-action-danger-default);
	font-size: 8px;
	color: var(--lok-color-text-inverse);
	border-radius: var(--lok-radius-rounded);
	width: 12px;
	height: 12px;
	line-height: 12px;
	text-align: center;
}

._tag_1pc1v_15 {
	background-color: var(--lok-color-background-active);
	border: none;
	color: var(--lok-color-background-action-primary-pressed);
}

._withLinkStyle_1pc1v_21 {
	cursor: pointer;
	font-size: inherit;
	font-weight: inherit;
	line-height: inherit;
	color: var(--lok-color-background-action-primary-default);
	background-color: transparent;
	padding: 0;
	border: none;
}

._withLinkStyle_1pc1v_21:hover,
._withLinkStyle_1pc1v_21:focus {
	color: var(--lok-color-background-action-primary-hover);
}

._withLinkStyle_1pc1v_21:active,
._withLinkStyle_1pc1v_21:active:hover {
	color: var(--lok-color-background-action-primary-pressed);
}

._withNavLinkStyle_1pc1v_42 {
	color: inherit;
	display: block;
	position: relative;
	padding-top: var(--lok-spacing-2);
	padding-bottom: 14px;
	background-color: transparent;
	text-decoration: none;
}

._withNavLinkStyle_1pc1v_42[disabled] {
	pointer-events: none;
}

._withNavLinkStyle_1pc1v_42._disabled_1pc1v_57 {
	color: var(--lok-color-text-disabled);
}

._projectNavigationItem_1pc1v_61 {
	display: flex;
	align-items: center;
	justify-content: space-between;
}

._projectNavigationItemDisabled_1pc1v_67 {
	opacity: 0.6;
	pointer-events: none;
}
._headerSortButton_b5tlh_1 {
	/* reset button styling as these should look like regular table headers */
	background: none;
	color: inherit;
	border: none;
	font: inherit;
	cursor: pointer;
	outline: inherit;

	display: inline-flex;
	align-items: center;
	gap: var(--lok-spacing-1);
}

._centeredCell_b5tlh_15 {
	text-align: center;
}

._rightAlignedCell_b5tlh_19 {
	text-align: right;
}
`, "",{"version":3,"sources":["webpack://./node_modules/@lokalise/harmony/dist/harmony.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,mCAAmC;CACnC,WAAW;CACX,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,gBAAgB;CAChB,eAAe;CACf,6CAA6C;CAC7C,UAAU;AACX;;AAEA;CACC,YAAY;CACZ,SAAS;CACT,oCAAoC;CACpC,gBAAgB;CAChB,gBAAgB;;CAEhB,8CAA8C;CAC9C,oCAAoC;CACpC,kCAAkC;;CAElC;EACC,gBAAgB;EAChB,mCAAmC;EACnC,iDAAiD;CAClD;AACD;;AAEA;CACC,eAAe;CACf,6DAA6D;CAC7D,MAAM;CACN,UAAU;CACV,WAAW;CACX,YAAY;;CAEZ,iCAAiC;CACjC,kBAAkB;CAClB,mBAAmB;CACnB,kBAAkB;CAClB,mBAAmB;CACnB,wDAAwD;AACzD;;AAEA;CACC,gCAAgC;CAChC,kBAAkB;CAClB,YAAY;CACZ,OAAO;CACP,QAAQ;CACR,cAAc;CACd,gBAAgB;AACjB;AACA;CACC,uDAAuD;CACvD,eAAe;CACf,WAAW;CACX,MAAM;CACN,OAAO;CACP,SAAS;CACT,4DAA4D;CAC5D,aAAa;CACb,8BAA8B;CAC9B,sBAAsB;CACtB,oCAAoC;CACpC,UAAU;AACX;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,YAAY;CACZ,kBAAkB;;CAElB;EACC,4DAA4D;CAC7D;;CAEA;EACC,WAAW;CACZ;AACD;AACA;CACC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,YAAY;CACZ,kBAAkB;;CAElB;EACC,4DAA4D;CAC7D;;CAEA;EACC,WAAW;CACZ;AACD;AACA;CACC,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,YAAY;CACZ,WAAW;CACX,uBAAuB;CACvB,YAAY;CACZ,aAAa;CACb,0CAA0C;;CAE1C;EACC,yDAAyD;EACzD,0DAA0D;CAC3D;AACD;;AAEA;CACC,yDAAyD;CACzD,0DAA0D;AAC3D;AACA;CACC,eAAe;CACf,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,YAAY;CACZ,WAAW;CACX,uBAAuB;CACvB,YAAY;CACZ,aAAa;CACb,0CAA0C;;CAE1C;EACC,yDAAyD;EACzD,0DAA0D;CAC3D;AACD;;AAEA;CACC,yDAAyD;CACzD,0DAA0D;AAC3D;AACA;CACC,kDAAkD;CAClD,mEAAmE;CACnE,mBAAmB;CACnB,eAAe;CACf,YAAY;CACZ,WAAW;AACZ;AACA;CACC,6BAA6B;CAC7B,2BAA2B;AAC5B;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;CAClC,qCAAqC;CACrC;;EAEC,qCAAqC;EACrC,kDAAkD;CACnD;AACD;;AAEA;CACC,eAAe;CACf,kBAAkB;CAClB,YAAY;CACZ,uBAAuB;CACvB,kCAAkC;CAClC,iCAAiC;;CAEjC;EACC,gBAAgB;CACjB;AACD;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,mBAAmB;CACnB,6DAA6D;CAC7D,mBAAmB,EAAE,iEAAiE;AACvF;;AAEA;CACC,mEAAmE;AACpE;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,wCAAwC;CACxC,uBAAuB;CACvB,YAAY;AACb;AACA;CACC,eAAe;AAChB;;AAEA;CACC,0CAA0C;CAC1C,oCAAoC;CACpC,eAAe;CACf,gBAAgB;CAChB,uBAAuB;AACxB;AACA;CACC,0BAA0B;AAC3B;;AAEA;CACC,kDAAkD;CAClD,yBAAyB;CACzB,aAAa;AACd;;AAEA;CACC,gCAAgC;CAChC,iCAAiC;CACjC,mBAAmB;CACnB,6DAA6D;CAC7D,mBAAmB;AACpB;;AAEA;CACC,uBAAuB;CACvB,aAAa;CACb,sBAAsB;CACtB,OAAO;CACP,QAAQ,EAAE,2CAA2C;CACrD,YAAY;AACb;;AAEA;CACC,mBAAmB;CACnB,aAAa;CACb,iBAAiB;CACjB,yBAAyB;CACzB,WAAW;AACZ;;AAEA;CACC,OAAO;CACP,6CAA6C;CAC7C,YAAY;CACZ,gBAAgB;CAChB,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,oDAAoD;CACpD,wCAAwC;CACxC,6CAA6C;CAC7C,iCAAiC,EAAE,2CAA2C;CAC9E,mBAAmB;AACpB;;AAEA;CACC,0CAA0C;CAC1C,4CAA4C;CAC5C,0BAA0B;AAC3B;;AAEA;CACC,gCAAgC;CAChC,iCAAiC;AAClC;AACA;CACC,0BAA0B;AAC3B;;AAEA;CACC,WAAW;CACX;;8EAE6E;CAC7E,iBAAiB;CACjB,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,gCAAgC;CAChC,iCAAiC;CACjC,mBAAmB;CACnB,6DAA6D;CAC7D,mBAAmB;AACpB;AACA;CACC,eAAe;CACf,YAAY;CACZ,kDAAkD;CAClD,sDAAsD;CACtD,SAAS;;CAET;EACC;GACC,oCAAoC;EACrC;CACD;AACD;;AAEA;CACC,8CAA8C;AAC/C;;AAEA;CACC,mCAAmC;CACnC,6CAA6C;CAC7C,YAAY;AACb;AACA;CACC,SAAS;CACT,gBAAgB;CAChB,WAAW;CACX,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,kBAAkB;CAClB,YAAY;CACZ,0CAA0C;;CAE1C;EACC,yDAAyD;EACzD,0DAA0D;CAC3D;AACD;;AAEA;CACC,yDAAyD;CACzD,0DAA0D;AAC3D;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,qBAAqB;;CAErB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,kBAAkB;;CAElB,WAAW;CACX,YAAY;CACZ,wCAAwC;CACxC,8CAA8C;;CAE9C,oCAAoC;CACpC,yBAAyB;CACzB,oCAAoC;AACrC;AACA;CACC,4CAA4C;CAC5C;EACC,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;;EAEjB;GACC;sDACmD;EACpD;CACD;AACD;;AAEA;CACC,0CAA0C;CAC1C,gBAAgB;AACjB;;AAEA;CACC,0CAA0C;;CAE1C;EACC,qBAAqB;EACrB,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,4BAA4B;EAC5B,yBAAyB;CAC1B;;CAEA;EACC;GACC,yBAAyB;EAC1B;CACD;;CAEA;EACC;GACC,yBAAyB;EAC1B;CACD;AACD;AACA;CACC,6BAA6B;CAC7B,kBAAkB;;CAElB;EACC,cAAc;EACd,WAAW;EACX,WAAW;EACX,4CAA4C;EAC5C,kBAAkB;EAClB,MAAM;EACN,0BAA0B;EAC1B,oDAAoD;CACrD;AACD;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,8CAA8C;CAC9C,gBAAgB;CAChB,uBAAuB;CACvB,uDAAuD;AACxD;;AAEA;CACC,0CAA0C;CAC1C,6CAA6C;CAC7C,gBAAgB;CAChB,uBAAuB;AACxB;;AAEA;CACC,mBAAmB;CACnB,gCAAgC;CAChC,WAAW;CACX,4CAA4C;CAC5C,yBAAyB;;CAEzB;EACC,iCAAiC;EACjC,oCAAoC;CACrC;;CAEA;;EAEC,kCAAkC;CACnC;;CAEA;;EAEC,kCAAkC;CACnC;;CAEA;;EAEC,mCAAmC;CACpC;;CAEA;EACC,0CAA0C;EAC1C,gBAAgB;EAChB,oCAAoC;EACpC,6CAA6C;EAC7C,yBAAyB;;EAEzB;GACC,YAAY;EACb;;EAEA;GACC,YAAY;EACb;;EAEA;GACC,WAAW;EACZ;;EAEA;GACC,YAAY;EACb;CACD;AACD;;AAEA;CACC,0CAA0C;CAC1C,gCAAgC;CAChC,6CAA6C;;CAE7C;EACC,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;;EAEtB;GACC,iCAAiC;EAClC;;EAEA;GACC,YAAY;GACZ,kCAAkC;EACnC;CACD;AACD;AACA;CACC,aAAa;CACb,YAAY;CACZ,UAAU;AACX;;AAEA;CACC,kBAAkB;CAClB,6BAA6B;CAC7B,YAAY;CACZ,UAAU;AACX;;AAEA;CACC,qCAAqC;AACtC;;AAEA;CACC,4CAA4C;CAC5C,0CAA0C;AAC3C;;AAEA;CACC,YAAY;CACZ,gBAAgB;CAChB,gBAAgB;CAChB,kBAAkB;CAClB,UAAU;AACX;AACA;CACC,0CAA0C;;CAE1C,qBAAqB;AACtB;;AAEA;CACC,8CAA8C;;CAE9C,mBAAmB;CACnB,gBAAgB;CAChB,uBAAuB;;CAEvB,kCAAkC;CAClC,cAAc;;CAEd;EACC,mBAAmB;CACpB;AACD;AACA;CACC,kBAAkB;CAClB,QAAQ;CACR,YAAY;CACZ,mEAAmE;CACnE,cAAc;CACd,oCAAoC;CACpC,wCAAwC;CACxC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,oDAAoD;CACpD,YAAY;CACZ,yDAAyD;AAC1D;;AAEA;CACC,eAAe;CACf,kBAAkB;CAClB,oBAAoB;CACpB,oBAAoB;CACpB,yDAAyD;CACzD,6BAA6B;CAC7B,UAAU;CACV,YAAY;AACb;;AAEA;;CAEC,uDAAuD;AACxD;;AAEA;;CAEC,yDAAyD;AAC1D;;AAEA;CACC,cAAc;CACd,cAAc;CACd,kBAAkB;CAClB,iCAAiC;CACjC,oBAAoB;CACpB,6BAA6B;CAC7B,qBAAqB;AACtB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,qCAAqC;AACtC;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,8BAA8B;AAC/B;;AAEA;CACC,YAAY;CACZ,oBAAoB;AACrB;AACA;CACC,yEAAyE;CACzE,gBAAgB;CAChB,cAAc;CACd,YAAY;CACZ,aAAa;CACb,eAAe;CACf,gBAAgB;;CAEhB,oBAAoB;CACpB,mBAAmB;CACnB,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,iBAAiB;AAClB","sourcesContent":["._headerContainer_1cubo_1 {\n\tdisplay: flex;\n\tmargin-bottom: var(--lok-spacing-1);\n\twidth: 100%;\n\talign-items: center;\n}\n\n._navigationTabList_1cubo_8 {\n\tdisplay: flex;\n\tlist-style: none;\n\tflex-wrap: wrap;\n\tmargin: 0 0 0 calc(-1 * var(--lok-spacing-6));\n\tpadding: 0;\n}\n\n._navigationTab_1cubo_8 {\n\tborder: none;\n\tmargin: 0;\n\tborder-bottom: 2px solid transparent;\n\tbackground: none;\n\tappearance: none;\n\n\tfont: var(--lok-typography-body-small-default);\n\tcolor: var(--lok-color-text-default);\n\tmargin: 0 0 0 var(--lok-spacing-6);\n\n\t&[aria-selected='true'] {\n\t\tfont-weight: 500;\n\t\tcolor: var(--lok-color-text-active);\n\t\tborder-bottom-color: var(--lok-color-text-active);\n\t}\n}\n\n._headerContent_1cubo_34 {\n\tposition: fixed;\n\tbackground-color: var(--lok-color-background-surface-default);\n\ttop: 0;\n\tleft: 95px;\n\tright: 32px;\n\tz-index: 899;\n\n\tpadding-top: var(--lok-spacing-5);\n\tpadding-left: 30px;\n\tpadding-right: 30px;\n\tmargin-left: -30px;\n\tmargin-right: -30px;\n\tborder-bottom: 1px solid var(--lok-color-border-default);\n}\n\n._staticEnabled_1cubo_50 {\n\tz-index: var(--lok-z-index-auto);\n\tposition: relative;\n\ttop: inherit;\n\tleft: 0;\n\tright: 0;\n\tpadding-top: 0;\n\tbox-shadow: none;\n}\n._sidebarContainer_bmdti_1 {\n\tborder-right: 1px solid var(--lok-color-border-default);\n\tposition: fixed;\n\twidth: 65px;\n\ttop: 0;\n\tleft: 0;\n\tbottom: 0;\n\tbackground-color: var(--lok-color-background-surface-middle);\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tflex-direction: column;\n\tpadding-bottom: var(--lok-spacing-3);\n\tz-index: 1;\n}\n\n._logoLink_bmdti_16 {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\theight: 67px;\n\tposition: relative;\n\n\t&:hover {\n\t\tbackground-color: var(--lok-color-background-surface-middle);\n\t}\n\n\t> img {\n\t\twidth: 36px;\n\t}\n}\n._logoLink_1baxb_1 {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\theight: 67px;\n\tposition: relative;\n\n\t&:hover {\n\t\tbackground-color: var(--lok-color-background-surface-middle);\n\t}\n\n\t> img {\n\t\twidth: 36px;\n\t}\n}\n._link_18vhx_1._link_18vhx_1 {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\theight: 65px;\n\twidth: 64px;\n\tbackground: transparent;\n\tborder: none;\n\toutline: none;\n\tcolor: var(--lok-color-text-light-default);\n\n\t&:hover {\n\t\tcolor: var(--lok-color-background-action-primary-default);\n\t\tbackground-color: var(--lok-color-background-surface-fore);\n\t}\n}\n\n._active_18vhx_18._active_18vhx_18 {\n\tcolor: var(--lok-color-background-action-primary-default);\n\tbackground-color: var(--lok-color-background-surface-fore);\n}\n._dropdownButton_1naek_1 {\n\tcursor: pointer;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\theight: 65px;\n\twidth: 64px;\n\tbackground: transparent;\n\tborder: none;\n\toutline: none;\n\tcolor: var(--lok-color-text-light-default);\n\n\t&:hover {\n\t\tcolor: var(--lok-color-background-action-primary-default);\n\t\tbackground-color: var(--lok-color-background-surface-fore);\n\t}\n}\n\n._dropdownButtonActive_1naek_19 {\n\tcolor: var(--lok-color-background-action-primary-default);\n\tbackground-color: var(--lok-color-background-surface-fore);\n}\n._iconContainer_nz34m_1 {\n\tcolor: var(--lok-color-background-surface-default);\n\tbackground-color: var(--lok-color-background-action-danger-default);\n\tborder-radius: 100%;\n\tfont-size: 10px;\n\theight: 16px;\n\twidth: 16px;\n}\n:root {\n\t--menu-container-width: 300px;\n\t--profile-button-size: 65px;\n}\n\n._popoverContent_1phdw_6 {\n\twidth: var(--menu-container-width);\n}\n\n._menuContainer_1phdw_10 {\n\twidth: var(--menu-container-width);\n\tfont-size: var(--lok-font-size-small);\n\tbutton,\n\ta {\n\t\tfont-size: var(--lok-font-size-small);\n\t\tpadding: var(--lok-spacing-3) var(--lok-spacing-4);\n\t}\n}\n\n._profileButton_1phdw_20 {\n\tcursor: pointer;\n\tposition: relative;\n\tborder: none;\n\tbackground: transparent;\n\theight: var(--profile-button-size);\n\twidth: var(--profile-button-size);\n\n\t&:hover {\n\t\tbackground: none;\n\t}\n}\n\n._profileImage_1phdw_33 {\n\twidth: 40px;\n\theight: 40px;\n\tborder-radius: 100%;\n\tbackground-color: var(--lok-color-background-surface-default);\n\tobject-fit: contain; /* Make sure that non-square images maintain their aspect ratio */\n}\n\n._profileImageHighlight_1phdw_41 {\n\tborder: 3px solid var(--lok-color-background-action-danger-default);\n}\n\n._profileImageUpgradeIcon_1phdw_45 {\n\tposition: absolute;\n\tbottom: 10px;\n\tright: 10px;\n}\n\n._userIconWrapper_1phdw_51 {\n\twidth: 45px;\n\theight: 45px;\n\tdisplay: flex;\n\talign-items: center;\n\tborder-radius: var(--lok-radius-rounded);\n\tjustify-content: center;\n\tmargin: auto;\n}\n._container_q5pot_1 {\n\tmax-width: 100%;\n}\n\n._profileEmail_q5pot_5 {\n\tcolor: var(--lok-color-text-light-default);\n\tfont-size: var(--lok-font-size-tiny);\n\tmax-width: 100%;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n}\n:root {\n\t--profile-image-size: 40px;\n}\n\n._wrapper_1in7x_5 {\n\tpadding: var(--lok-spacing-3) var(--lok-spacing-4);\n\tgap: var(--lok-spacing-2);\n\tdisplay: flex;\n}\n\n._profileImage_1in7x_11 {\n\twidth: var(--profile-image-size);\n\theight: var(--profile-image-size);\n\tborder-radius: 100%;\n\tbackground-color: var(--lok-color-background-surface-default);\n\tobject-fit: contain;\n}\n\n._teamDetails_1in7x_19 {\n\talign-items: flex-start;\n\tdisplay: flex;\n\tflex-direction: column;\n\tflex: 1;\n\tgap: 1px; /* TODO: use spacing token when available */\n\tmin-width: 0;\n}\n\n._planWrapper_1in7x_28 {\n\talign-items: center;\n\tdisplay: flex;\n\tflex-wrap: nowrap;\n\tgap: var(--lok-spacing-2);\n\twidth: 100%;\n}\n\n._teamName_1in7x_36 {\n\tflex: 1;\n\tfont: var(--lok-typography-body-base-default);\n\tmin-width: 0;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\twhite-space: nowrap;\n}\n\n._planLabel_1in7x_45 {\n\tbackground-color: var(--lok-color-background-danger);\n\tborder-radius: var(--lok-radius-rounded);\n\tfont: var(--lok-typography-body-tiny-default);\n\tpadding: 2px var(--lok-spacing-2); /* TODO: use spacing token when available */\n\twhite-space: nowrap;\n}\n\n._membership_1in7x_53 {\n\tcolor: var(--lok-color-text-light-default);\n\tfont: var(--lok-typography-body-action-base);\n\ttext-transform: capitalize;\n}\n\n._defaultProfileImage_1in7x_59 {\n\twidth: var(--profile-image-size);\n\theight: var(--profile-image-size);\n}\n:root {\n\t--profile-image-size: 40px;\n}\n\n._teamsContainer_1ncrr_5 {\n\twidth: 100%;\n\t/* Fix for overflowing menu when there is a lot of teams to select from.\n     * This should be changed in the future to something more user friendly.\n     * Fits easily 5 teams (on landscape iPad) - should cover 95%+ of cases. */\n\tmax-height: 350px;\n\toverflow-x: hidden;\n\toverflow-y: auto;\n}\n\n._profileImage_1ncrr_15 {\n\twidth: var(--profile-image-size);\n\theight: var(--profile-image-size);\n\tborder-radius: 100%;\n\tbackground-color: var(--lok-color-background-surface-default);\n\tobject-fit: contain;\n}\n._container_1u995_1 {\n\tmax-width: 100%;\n\tmin-width: 0;\n\tpadding: var(--lok-spacing-3) var(--lok-spacing-4);\n\tbackground: var(--lok-color-background-surface-middle);\n\tborder: 0;\n\n\t&:hover {\n\t\t._upgrade-icon_1u995_9 {\n\t\t\tcolor: var(--lok-color-text-inverse);\n\t\t}\n\t}\n}\n\n._planCta_1u995_15 {\n\tfont: var(--lok-typography-body-small-default);\n}\n\n._upgradeIconWrapper_1u995_19 {\n\tcolor: var(--lok-color-text-danger);\n\tfont: var(--lok-typography-body-small-strong);\n\theight: 16px;\n}\n._navItem_1dudv_1._navItem_1dudv_1 {\n\tborder: 0;\n\tbackground: none;\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tposition: relative;\n\theight: 65px;\n\tcolor: var(--lok-color-text-light-default);\n\n\t&:hover {\n\t\tcolor: var(--lok-color-background-action-primary-default);\n\t\tbackground-color: var(--lok-color-background-surface-fore);\n\t}\n}\n\n._activeNavItem_1dudv_18 {\n\tcolor: var(--lok-color-background-action-primary-default);\n\tbackground-color: var(--lok-color-background-surface-fore);\n}\n\n._badge_1dudv_23 {\n\tposition: absolute;\n\ttop: calc(50% - 16px);\n\tleft: calc(50% + 2px);\n\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\ttext-align: center;\n\n\twidth: 16px;\n\theight: 16px;\n\tborder-radius: var(--lok-radius-rounded);\n\tbackground-color: var(--lok-color-text-danger);\n\n\tfont-size: var(--lok-font-size-tiny);\n\ttext-transform: uppercase;\n\tcolor: var(--lok-color-text-inverse);\n}\n._langRowCompleted_vpgdi_1 {\n\tbackground: var(--lok-color-background-info);\n\ttd {\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t\ttext-align: start;\n\n\t\t&:first-child {\n\t\t\tborder-left: 2px solid\n\t\t\t\tvar(--lok-color-background-action-primary-default);\n\t\t}\n\t}\n}\n\n._langCellSecondary_vpgdi_15 {\n\tcolor: var(--lok-color-text-light-default);\n\ttext-align: left;\n}\n\n._langStatus_vpgdi_20 {\n\tcolor: var(--lok-color-text-light-default);\n\n\t&::before {\n\t\tdisplay: inline-block;\n\t\tcontent: '';\n\t\twidth: 6px;\n\t\theight: 6px;\n\t\tborder-radius: 50%;\n\t\tmargin: var(--lok-spacing-1);\n\t\tbackground-color: #cbd5e0;\n\t}\n\n\t&[data-status='completed'] {\n\t\t&::before {\n\t\t\tbackground-color: #60e778;\n\t\t}\n\t}\n\n\t&[data-status='in_progress'] {\n\t\t&::before {\n\t\t\tbackground-color: #facc15;\n\t\t}\n\t}\n}\n._taskContainer_mt2or_1 {\n\tpadding: var(--lok-spacing-4);\n\tposition: relative;\n\n\t&:not(:first-child)::before {\n\t\tdisplay: block;\n\t\tcontent: '';\n\t\theight: 1px;\n\t\twidth: calc(100% - 2 * var(--lok-spacing-4));\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: var(--lok-spacing-4);\n\t\tbackground: var(--lok-color-background-surface-fore);\n\t}\n}\n\n._tagDue_mt2or_17 {\n\tbackground: #dea829;\n}\n\n._taskTitle_mt2or_21 {\n\tfont: var(--lok-typography-body-small-default);\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\tmargin-block: var(--lok-spacing-4) var(--lok-spacing-2);\n}\n\n._taskDescription_mt2or_28 {\n\tcolor: var(--lok-color-text-light-default);\n\tfont: var(--lok-typography-body-action-small);\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n}\n\n._languagesTable_mt2or_35 {\n\ttable-layout: fixed;\n\tmargin-top: var(--lok-spacing-3);\n\twidth: auto;\n\tmargin-left: calc(var(--lok-spacing-4) * -1);\n\tborder-collapse: separate;\n\n\ttbody td {\n\t\tpadding-top: var(--lok-spacing-1);\n\t\tpadding-bottom: var(--lok-spacing-1);\n\t}\n\n\tthead th:first-child,\n\ttbody td:first-child {\n\t\tpadding-left: var(--lok-spacing-4);\n\t}\n\n\tthead th,\n\ttbody td {\n\t\tpadding-left: var(--lok-spacing-2);\n\t}\n\n\tthead th:last-child,\n\ttbody td:last-child {\n\t\tpadding-right: var(--lok-spacing-4);\n\t}\n\n\tthead tr th {\n\t\tcolor: var(--lok-color-text-light-default);\n\t\ttext-align: left;\n\t\tpadding-bottom: var(--lok-spacing-1);\n\t\tfont: var(--lok-typography-body-tiny-default);\n\t\ttext-transform: uppercase;\n\n\t\t&:nth-child(1) {\n\t\t\twidth: 170px;\n\t\t}\n\n\t\t&:nth-child(2) {\n\t\t\twidth: 107px;\n\t\t}\n\n\t\t&:nth-child(3) {\n\t\t\twidth: 75px;\n\t\t}\n\n\t\t&:nth-child(4) {\n\t\t\twidth: 118px;\n\t\t}\n\t}\n}\n\n._metadata_mt2or_87 {\n\tcolor: var(--lok-color-text-light-default);\n\tmargin: var(--lok-spacing-4) 0 0;\n\tfont: var(--lok-typography-body-tiny-default);\n\n\t> span {\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t\tflex-basis: 100%;\n\t\tmax-width: max-content;\n\n\t\t&:not(:first-child) {\n\t\t\tmargin-left: var(--lok-spacing-1);\n\t\t}\n\n\t\t&:not(:first-child)::before {\n\t\t\tcontent: '•';\n\t\t\tmargin-right: var(--lok-spacing-1);\n\t\t}\n\t}\n}\n._loadingContainer_19d6m_1 {\n\theight: 100px;\n\twidth: 487px;\n\tleft: 69px;\n}\n\n._noTasksContainer_19d6m_7 {\n\ttext-align: center;\n\tpadding: var(--lok-spacing-8);\n\twidth: 360px;\n\tleft: 65px;\n}\n\n._noTasksHeading_19d6m_14 {\n\tfont: var(--lok-typography-heading-3);\n}\n\n._noTasksText_19d6m_18 {\n\tfont: var(--lok-typography-body-action-base);\n\tcolor: var(--lok-color-text-light-default);\n}\n\n._tasksContainer_19d6m_23 {\n\twidth: 487px;\n\tmax-height: 70vh;\n\toverflow-y: auto;\n\toverflow-x: hidden;\n\tleft: 65px;\n}\n._breadcrumbsItem_1hm6a_1 {\n\tcolor: var(--lok-color-text-light-default);\n\n\ttext-decoration: none;\n}\n\n._breadcrumbs_1hm6a_1 {\n\tfont: var(--lok-typography-body-small-default);\n\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\n\tmargin-right: var(--lok-spacing-1);\n\tmax-width: 90%;\n\n\t& > * {\n\t\twhite-space: nowrap;\n\t}\n}\n._badge_1pc1v_1 {\n\tposition: absolute;\n\ttop: 5px;\n\tright: -13px;\n\tbackground-color: var(--lok-color-background-action-danger-default);\n\tfont-size: 8px;\n\tcolor: var(--lok-color-text-inverse);\n\tborder-radius: var(--lok-radius-rounded);\n\twidth: 12px;\n\theight: 12px;\n\tline-height: 12px;\n\ttext-align: center;\n}\n\n._tag_1pc1v_15 {\n\tbackground-color: var(--lok-color-background-active);\n\tborder: none;\n\tcolor: var(--lok-color-background-action-primary-pressed);\n}\n\n._withLinkStyle_1pc1v_21 {\n\tcursor: pointer;\n\tfont-size: inherit;\n\tfont-weight: inherit;\n\tline-height: inherit;\n\tcolor: var(--lok-color-background-action-primary-default);\n\tbackground-color: transparent;\n\tpadding: 0;\n\tborder: none;\n}\n\n._withLinkStyle_1pc1v_21:hover,\n._withLinkStyle_1pc1v_21:focus {\n\tcolor: var(--lok-color-background-action-primary-hover);\n}\n\n._withLinkStyle_1pc1v_21:active,\n._withLinkStyle_1pc1v_21:active:hover {\n\tcolor: var(--lok-color-background-action-primary-pressed);\n}\n\n._withNavLinkStyle_1pc1v_42 {\n\tcolor: inherit;\n\tdisplay: block;\n\tposition: relative;\n\tpadding-top: var(--lok-spacing-2);\n\tpadding-bottom: 14px;\n\tbackground-color: transparent;\n\ttext-decoration: none;\n}\n\n._withNavLinkStyle_1pc1v_42[disabled] {\n\tpointer-events: none;\n}\n\n._withNavLinkStyle_1pc1v_42._disabled_1pc1v_57 {\n\tcolor: var(--lok-color-text-disabled);\n}\n\n._projectNavigationItem_1pc1v_61 {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n}\n\n._projectNavigationItemDisabled_1pc1v_67 {\n\topacity: 0.6;\n\tpointer-events: none;\n}\n._headerSortButton_b5tlh_1 {\n\t/* reset button styling as these should look like regular table headers */\n\tbackground: none;\n\tcolor: inherit;\n\tborder: none;\n\tfont: inherit;\n\tcursor: pointer;\n\toutline: inherit;\n\n\tdisplay: inline-flex;\n\talign-items: center;\n\tgap: var(--lok-spacing-1);\n}\n\n._centeredCell_b5tlh_15 {\n\ttext-align: center;\n}\n\n._rightAlignedCell_b5tlh_19 {\n\ttext-align: right;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
